// extracted by mini-css-extract-plugin
export default {"header":"Header_header__1D7lQ","header_menu":"Header_header_menu__ork+p"};